import { PATH_CONFIG } from "./paths.config";
import { ROUTES_CONFIG } from "./route.config";

// Build compartido para todos los centros comerciales. Los campos de sitio
// (idCentroComercial, centroComercial, nombreCentroComercial, imageIcon, jumpCube,
// routeLogin, routeLoginClient) se completan en runtime en main.ts a partir de
// assets/centros-comerciales.json, según la carpeta desde la que se sirve la app.
export const environment = {
    multiSite: true,
    name: '',
    idCentroComercial: 0,
    centroComercial: '',
    nombreCentroComercial: '',
    routeLogin: './dashboard',
    routeLoginClient: './dashboard/facturas/register',
    imageIcon: '',
    jumpCube: false,
    paths: PATH_CONFIG,
    routeImg: '',
    ...ROUTES_CONFIG,
};
